module.exports = __webpack_public_path__ + "img/未标题-3-03.1bf2651f.png";